export default __webpack_public_path__ + "e49c8a127fb2bec61d7afbaad352dc5c.svg";